<template>
  <div class="single-quantity-entry">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="100px">
        <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.warehouseId"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-button class="btn-blue" @click="search">搜索</el-button>
        <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white order-nums"
          icon="el-icon-setting"
          @click="openActualOrderNums('forecastQuantity')"
          >预报单量</el-button
        >
        <el-button 
          class="btn-white order-nums"
          icon="el-icon-setting"
          @click="openActualOrderNums('actualQuantity')"
          >实际单量</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>
    
    <!-- 单量设置 -->
    <el-dialog
      :title="title"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="order-nums-dialog"
    >
      <el-form class="order-nums-form" ref="orderNumsForm" :model="orderNumsForm" :rules="rules">
        <el-form-item label="仓库" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="orderNumsForm.warehouseId"
            placeholder="请选择仓库"
            @change="changeWarehouse"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="orderNumsForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="table">
        <el-table :data="tableActualList" style="width: 100%;">
          <el-table-column
            prop="projectName"
            label="项目名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="actualOrderNums" :label="orderNumsType === 'actualQuantity' ?'实际单量':'预报单量'">
            <template slot-scope="scope">
              <el-input
                class="white"
                v-model="scope.row.actualOrderNums"
                @input="inputActualOrderNums(scope.$index, scope.row.actualOrderNums)"
                @blur="blurActualOrderNums(scope.row.id, scope.row.actualOrderNums)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('orderNumsForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import SingleQuantity from "models/data-entry/single-quantity";
import { formatTimeToDate, getInteger } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'date', width: '150'},
        {label: '项目名称', prop: 'projectName', width: '200'},
        {label: '预报单量', prop: 'forecastQuantity', width: ''},
        {label: '实际单量', prop: 'actualQuantity', width: ''},
      ],
      warehouseList: [],
      searchForm: {
        warehouseId: '',
        date: ''
      },
      dialog: false,
      title: '实际单量设置',
      orderNumsType: 'actualQuantity',
      orderNumsTypeObj: {
        'forecastQuantity': '预报单量设置',
        'actualQuantity': '实际单量设置',
      },
      orderNumsForm: {
        warehouseId: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
      tableActualList: [],
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    
    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let date = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        date
      }
      SingleQuantity.getSingleQuantityEntryList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.date = i.date
            obj.projectName = i.projectName
            obj.forecastQuantity = i.exceptOrderNum
            obj.actualQuantity = i.receiveOrderNum
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 实际单量设置 */
    initActualList() {
      let date = this.orderNumsForm.date
      let warehouseId = this.orderNumsForm.warehouseId
      let data = {
        date,
        warehouseId
      }
      SingleQuantity.getActualList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.projectName = i.projectName
            obj.actualOrderNums = i.receiveOrderNum
            arr.push(obj)
          })
          this.tableActualList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 预计单量列表 */
    initForecastList() {
      let date = this.orderNumsForm.date
      let warehouseId = this.orderNumsForm.warehouseId
      let data = {
        date,
        warehouseId
      }
      SingleQuantity.getForecastList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.projectName = i.projectName
            obj.actualOrderNums = i.exceptOrderNum
            arr.push(obj)
          })
          this.tableActualList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    initOrderNums() {
      if (this.orderNumsType === 'actualQuantity') this.initActualList()
      if (this.orderNumsType === 'forecastQuantity') this.initForecastList()
    },

    changeWarehouse() {
      this.initOrderNums()
    },

    changeDate() {
      this.initOrderNums()
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    
    async openActualOrderNums(type) {
      this.orderNumsType = type
      this.title = this.orderNumsTypeObj[type]
      this.orderNumsForm.warehouseId = await this.warehouseList.length > 0 ? this.warehouseList[0].id : '';
      this.orderNumsForm.date = await formatTimeToDate(new Date().getTime() - 60*60*24*1000)
      if (type === 'actualQuantity') await this.initActualList()
      if (type === 'forecastQuantity') await this.initForecastList()
      this.dialog = true
    },
    
    inputActualOrderNums(index, price) {
      let actualOrderNums = getInteger(price);
      this.tableActualList[index].actualOrderNums = actualOrderNums;
    },

    blurActualOrderNums(projectId, receiveOrderNum) {
      let date = this.orderNumsForm.date
      let data = {
        date,
        projectId,
      }
      if (this.orderNumsType === 'actualQuantity') {
        data.receiveOrderNum = receiveOrderNum
        SingleQuantity.postSaveActual(data).then(res => {
          if (!res.success) {
            this.$message.error(res.message)
          }
        })
      } else {
        data.exceptOrderNum = receiveOrderNum
        SingleQuantity.postSaveForecast(data).then(res => {
          if (!res.success) {
            this.$message.error(res.message)
          }
        })
      }
    },

    closeDialog() {
      this.orderNumsForm.warehouseId = ''
      this.orderNumsForm.date = ''
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.closeDialog()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style lang='scss'>
.single-quantity-entry {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .order-nums {
      padding: 0px 14px;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 72px;
      .el-form-item {
        margin-bottom: 0px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
  }
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .order-nums-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .order-nums-form {
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
    }
    .table {
      padding: 0px;
      margin-top: 20px;
      .el-table {
        .el-table__body-wrapper {
          height: 250px;
          overflow-y: auto;
        }
        .el-input {
          width: 160px;
          .el-input__inner {
            height: 24px;
            width: 160px;
            padding-left: 10px;
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
